export enum FormTypeEnum {
  COMMERCIAL = 'commercial',
  RESIDENTIAL = 'residential'
}
